import { JwtAxios, BrandJwtAxios } from '@/packaging';

export const productApi = {
  async SearchProduct(model) {
    const res = await JwtAxios.post(`/Product/SearchProduct`, model);
    return res;
  },
  async GetLuxItemListByCategory() {
    const res = await JwtAxios.post(`/Product/GetLuxItemListByCategory`);
    return res;
  },
  async getDashBoardData() {
    const res = await JwtAxios.get(`/Product/getDashBoardData`);
    return res;
  },
  async getcharts() {
    const res = await JwtAxios.get(`/Product/getcharts`);
    return res;
  },

  async RemoveProduct(model) {
    const res = await JwtAxios.delete(`/Product/RemoveProduct`, model);
    return res;
  },
  async SearchBrandProduct(model) {
    const res = await JwtAxios.post(`/Product/LuxItemList`, model);
    return res;
  },
  async GetMemo(id) {
    const res = await JwtAxios.get(`/Product/GetMemo?id=${id}`);
    return res;
  },
  async SetMemo(model) {
    const res = await JwtAxios.patch('/Product/SetMemo', model);
    return res;
  },
  async getProductBasicInfo(id) {
    const res = await JwtAxios.get(`/Product/GetProductBasicInfo?id=${id}`);
    return res;
  },
  async updateProductBasicInfo(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductBasicInfo`, body);
    return res;
  },
  async getProductMainImages(id) {
    const res = await JwtAxios.get(`/Product/GetProductMainImages?id=${id}`);
    return res;
  },
  async updateProductMainImages(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductMainImages`, body);
    return res;
  },
  async SetProductMainImagesNukki(body) {
    const res = await JwtAxios.patch(`/Product/SetProductMainImagesNukki`, body);
    return res;
  },
  async getProductOptionGroups(id) {
    const res = await JwtAxios.get(`/Product/GetProductOptionGroups?id=${id}`);
    return res;
  },
  async convertDetailOption(id, body) {
    const res = await JwtAxios.post(`/Product/ConvertDetailOption?id=${id}`, body);
    return res;
  },
  async getPricingInfo(id) {
    const res = await JwtAxios.get(
      `/Product/GetPricingInfo?id=${id}`);
    return res;
  },
  async updateProductOption(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductOption`, body);
    return res;
  },
  async getProductDetailPage(id) {
    const res = await JwtAxios.get(`/Product/GetProductDetailPage?id=${id}`);
    return res;
  },
  async updateProductDetailPage(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductDetailPage`, body);
    return res;
  },
  async getProductShopeeAddInfo(id) {
    const res = await JwtAxios.get(`/Product/GetProductShopeeAddInfo?id=${id}`);
    return res;
  },
  async updateProductShopeeAddInfo(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductShopeeAddInfo?id=` + body.id, body.data);
    return res;
  },
  async VulkDelete(body) {
    const res = await JwtAxios.delete(`/Product/VulkDelete`, body);
    return res;
  },
  async GetUploadFailLog(body) {
    const res = await JwtAxios.post(`/Product/GetUploadFailLog`, body);
    return res;
  },
  async DownloadExcel(body) {
    const res = await JwtAxios.excelMultiPartPost('/Product/GetGoodsListDownloadExcel', body);
    return res;
  },
  async DownloadAllExcel(model) {
    const res = await JwtAxios.excelMultiPartPost(`/Product/GetTotalGoodsListDownloadExcel`, model);
    return res;
  },
  async GetTotalGoodsCount(model) {
    const res = await JwtAxios.post(`/Product/GetTotalGoodsCount`, model);
    return res;
  },
  async DownloadExcelBatch(model, batchNo) {
    const res = await JwtAxios.excelMultiPartPost(`/Product/GetGoodsListDownloadExcelBatch?batchNo=${batchNo}`, model);
    return res;
  },
  async uploadExcel(formData) {
    const res = await JwtAxios.upload('/Product/SetGoodsListUploadExcel', formData);
    return res;
  },
  // 상품정보(썸네일/상품명/상세) 엑셀 - 선택 상품 다운로드
  async DownloadFullExcel(body) {
    const res = await JwtAxios.excelMultiPartPost('/Product/GetGoodsFullDownloadExcel', body);
    return res;
  },
  // 상품정보(썸네일/상품명/상세) 엑셀 - 조회조건 전체를 배치로 다운로드
  async DownloadFullExcelBatch(model, batchNo, batchSize) {
    const res = await JwtAxios.excelMultiPartPost(
      `/Product/GetGoodsFullDownloadExcelBatch?batchNo=${batchNo}&batchSize=${batchSize}`,
      model
    );
    return res;
  },
  // 상품정보(썸네일/상품명/상세) 엑셀 - 일괄수정 업로드
  async uploadFullExcel(formData) {
    const res = await JwtAxios.upload('/Product/SetGoodsFullUploadExcel', formData);
    return res;
  },
  async GetKeywords(params) {
    const res = await JwtAxios.get(`/Product/GetKeywords`, params);
    return res;
  },
  async RestoreOriginalMainImage(productId) {
    const res = await JwtAxios.get(`/Product/RestoreOriginalMainImage?productId=${productId}`);
    return res;
  },
  async ReprocessAIImage(productId) {
    const res = await JwtAxios.get(`/Product/ReprocessAIImage?productId=${productId}`);
    return res;
  },
  async ReprocessAIImageBatch(productIds) {
    const res = await JwtAxios.post(`/Product/ReprocessAIImageBatch`, productIds);
    return res;
  },
  async RecalculateSalePrices(body) {
    const res = await JwtAxios.post(`/Product/RecalculateSalePrices`, body);
    return res;
  },
  async UpdateShippingAgencyFee(body) {
        const res = await JwtAxios.post(`/Product/UpdateShippingAgencyFee`, body);
        return res;
  },
  async SetCoupangBrand(model) {
    const res = await JwtAxios.post(`/Product/SetCoupangBrand`, model);
    return res;
  },
  // 등록상품관리 - 상품별 조회수 내역 (일자별 / 마켓별)
  // body: { productId, startDate, endDate }
  async GetProductViewHistory(body) {
    const res = await JwtAxios.post(`/Product/GetProductViewHistory`, body);
    return res;
  },
  // 등록상품관리 - 상품별 판매내역 (주문 목록 / 마켓별 집계)
  // body: { productId, productCode, startDate, endDate }
  async GetProductSalesHistory(body) {
    const res = await JwtAxios.post(`/Product/GetProductSalesHistory`, body);
    return res;
  },
};
